// import axios from "axios";
import axios from "../utils/axiosConfig";
import { IInvoiceData, ISalesRegisterFilters, ISalesRegisterResponse } from "../Interfaces/IInvoice";
const { BASE_URL } = require("../utils/urls");
//const API_BASE_URL = "https://panaccoapi-453601304730.asia-south1.run.app/api";
//const API_BASE_URL = "http://localhost:8080/api";
const API_BASE_URL=`${BASE_URL}/api`;
export const createInvoice = async (invoiceData: IInvoiceData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/invoice/createInvoice`,
      invoiceData
    );
    return response.data;
  } catch (error: any) {
    console.error("Error creating invoice:", error);
    throw error.response?.data || error;
  }
};

//To Get the Invoice for Orgs.
export const getInvoices = async (orgId: string) => {
    const response = await axios.get(`${API_BASE_URL}/invoice/getInvoice`, {
      params: { orgId },
    });
    return response.data.invoices;
  };
  
  export const deleteInvoice = async (invoiceId: string, orgId: string, updatedBy: string,invoiceType:string) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/invoice/deleteInvoice`,
        { invoiceId, orgId, updatedBy,invoiceType},
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch{
      console.error("Error in deleteInvoice API call:");
    }
  };

export const editInvoice = async (invoiceData: IInvoiceData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/invoice/updateInvoice`,
      invoiceData
    );

    return response.data;
  } catch (error: any) {
    console.error("Error updating invoice:", error);
    // Optional: backend error message fallback
    throw error.response?.data || error;
  }
};
  //To Get the Invoice by Invoice Id and OrgId.
  export const getInvoiceById = async (invoiceId:string ,orgId: string) => {
    const response = await axios.get(`${API_BASE_URL}/invoice/getInvoiceById`, {
      params: {invoiceId, orgId },
    });
    return response.data.invoice;
  };
  //To Get the next new Invoice number for Org.
export const getInvoicesNumber = async (orgId: string) => {
    const response = await axios.get(`${API_BASE_URL}/invoice/getLatestInvoiceIdForOrg`, {
      params: { orgId },
    }); 
    return response.data.invoiceId;
  };
//To Get the next new Performa Invoice number for Org.
  export const getPerformaInvoicesNumber = async (orgId: string) => {
    const response = await axios.get(`${API_BASE_URL}/invoice/getPerformaLatestInvoiceIdForOrg`, {
      params: { orgId },
    });
    return response.data.invoiceId;
  };
  //Convert image to base64string 
  export const getBase64FromImageUrl = async (imageUrl: string): Promise<string> => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }
//Reports-

 
// ─── API call ─────────────────────────────────────────────────────────────────
 
/**
 * Fetch a paginated, filtered Sales Register.
 *
 * Usage:
 *   const data = await getSalesRegister(orgId, {
 *     fromDate: "2025-04-01", toDate: "2026-03-31",
 *     status: "due", page: 1, limit: 20
 *   });
 */
export const getSalesRegister = async (
  orgId: string,
  filters: ISalesRegisterFilters = {}
): Promise<ISalesRegisterResponse> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/invoice/salesRegister`, {
      params: {
        orgId,
        fromDate:    filters.fromDate    || undefined,
        toDate:      filters.toDate      || undefined,
        customerId:  filters.customerId  || undefined,
        status:      filters.status      || undefined,
        invoiceType: filters.invoiceType || undefined,
        search:      filters.search      || undefined,
        sortField:   filters.sortField   || "invoiceDate",
        sortOrder:   filters.sortOrder   || "desc",
        page:        filters.page        ?? 1,
        limit:       filters.limit       ?? 20,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching sales register:", error?.response?.data || error?.message);
    throw new Error(error?.response?.data?.message || "Failed to fetch sales register");
  }
};
 